import ElElements from 'vue-el-element'
import vueVimeoPlayer from 'vue-vimeo-player'

export default (Vue) => {
  Object.entries(ElElements)
    .forEach(([type, ElElement]) => {
      Vue.component(type, ElElement)
    })

  Vue.use(vueVimeoPlayer)
}
